// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1nmTs","title":"ClientCherryInfo_title__2AibK","itemText":"ClientCherryInfo_itemText__3b30y"};